import {
  SET_MAP_SQUARES,
  // UPDATE_MAP_SQUARES,
  SET_MAP_MISSIONS,
 } from '~/store/map/mutation-types';
import MissionsAPI from '~/services/api/MissionsAPI';

export async function setSquares({ commit }, squares) {
  try {
    commit(SET_MAP_SQUARES, squares);
    return Promise.resolve(squares.data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function fetchMissions({ commit }, { filters }) {
  try {
    const missions = await MissionsAPI.fetchMapMissions(filters);
    // commit(SET_MAP_SQUARES, squares);
    commit(SET_MAP_MISSIONS, missions.data);
    // commit(UPDATE_MAP_SQUARES, missions.data);
    return Promise.resolve(missions.data);
  } catch (error) {
    return Promise.reject(error);
  }
}
